import React from "react";

const NoResults = (props) => {
  return (
    <div>
      <h3 className="NoResults">no results found</h3>
    </div>
  );
};

export default NoResults;
